import { atom } from "recoil";
export const QCCaseReportDataState = atom({
    key: "QCCaseReportDataState", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
